import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Cabinet } from '../cabinet/cabinet.model';

const axios = useAxios();

export interface FiscalYearCabinetService {
  Fetch: (fiscalYearId: number) => Promise<AxiosResponse<Cabinet[]>>;
}

const Fetch = (fiscalYearId: number): Promise<AxiosResponse<Cabinet[]>> =>
  axios.Get<Cabinet[]>(`/api/fiscalyears/${fiscalYearId}/cabinets/all`);

export default { Fetch } as FiscalYearCabinetService;
